import React from 'react';
import { Datagrid, EditButton, DeleteButton, List, TextField, NumberField, BooleanField } from 'react-admin';

const CategoryList = (props: any) => (
    <List {...props} perPage={25} bulkActionButtons={false} sort={{ field: 'page', order: 'ASC' }}>
        <Datagrid>
            <TextField source="name" />
            <NumberField source="short" />
            <BooleanField source="live" />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export default CategoryList;
